<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>



<!-- Navigation -->
<!-- wait for the navigation, organisation and user to be loaded before rendering. -->
<ng-container *ngIf="navigation && organisation && user">
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="isScreenMedium ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation?.default"
        [opened]="!isScreenMedium"
    >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationHeader>
        <!-- Logo -->
        <div class="flex-row items-center p-6 pb-0">
            <div *ngIf="!organisation?.logo">
                <h2 class="text-gray-900 dark:text-gray-100 flex-inline text-2xl font-bold line-height-1">{{organisation.name}} <br/> 
                    <div class="flex justify-end mt-2 items-center">
                        <span class="text-gray-900 dark:text-gray-100 p-0 m-0 flex text-sm mr-1">powered by </span>
                        <img
                            class="w-14 dark:hidden"
                            src="images/logo/logo-text.svg"
                            alt="Logo image"
                        />
                        
                        <img
                            class="hidden w-14 dark:flex"
                            src="images/logo/logo-text-on-dark.svg"
                            alt="Logo image"
                        />
                    </div>
                </h2>
            </div>
            <div *ngIf="organisation?.logo">
                <img [src]="organisation.logo"  alt="Logo image" class="w-full" />
                <div class="flex justify-end mt-2 items-center">
                    <span class="text-gray-900 dark:text-gray-100 p-0 m-0 flex text-sm mr-1">powered by </span>
                    <img
                        class="w-14 dark:hidden"
                        src="images/logo/logo-text.svg"
                        alt="Logo image"
                    />
                    
                    <img
                        class="hidden w-14 dark:flex"
                        src="images/logo/logo-text-on-dark.svg"
                        alt="Logo image"
                    />
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <!-- Organisation switcher -->
        <div *ngIf="organisation" class="flex w-full items-center border-t px-6 py-8">
            <organisation-switcher></organisation-switcher>
        </div>
    </ng-container>
</fuse-vertical-navigation>
</ng-container>
<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <!-- <organisation-switcher></organisation-switcher> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <notifications></notifications> -->
            <user></user>
        </div>
    </div>

    <!-- Subscription Warning Banner -->
    <div>
        <subscription-warning></subscription-warning>
    </div>

    <!-- Maintenance Banner -->
    <maintenance-banner></maintenance-banner>
    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Plugya &copy; {{ currentYear }}</span
        >
    </div>
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
